import { ToastProps } from '@/store/ToastContextProvider';
import { Icon } from '@successmode-ktp/kui';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Portal from '@/components/common/Portal';

function Toast({ id, message, onClose, duration = 5000 }: ToastProps) {
  const [isOpened, setIsOpened] = useState(false);

  useEffect(() => {
    if (!!id) {
      setIsOpened(true);
    }

    // 닫힐 때 메세지부터 사라지는 이슈 해결
    const openedTimer = setTimeout(() => {
      setIsOpened(false);
    }, duration - 200);

    const toastTimer = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      clearTimeout(openedTimer);
      clearTimeout(toastTimer);
    };
  }, [id, duration, onClose]);

  return (
    <Portal>
      <ToastWrapper hasId={id !== ''} opened={isOpened}>
        <Icon.CheckFilled size={24} fillColor='#20D557' />
        <Message>{message}</Message>
      </ToastWrapper>
    </Portal>
  );
}

const ToastWrapper = styled.aside<{ hasId: boolean; opened: boolean }>`
  position: fixed;
  bottom: 128px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #3a3b3e;
  padding: 0 24px;
  display: ${({ hasId }) => (hasId ? 'inline-flex' : 'none')};
  gap: 8px;
  align-items: center;
  justify-content: center;
  height: 56px;
  white-space: nowrap;
  border-radius: 8px;
  z-index: 1000;
  opacity: ${({ opened }) => (opened ? '1' : '0')};
  transition: all 200ms;
`;

const Message = styled.p`
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
`;

export default Toast;
